import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
let swiperInstances = [];

window.addEventListener('load', () => {
    handleSwiperInit();
});

window.addEventListener('resize', () => {
    handleSwiperInit();
});

// debounce helper
function debounce(fn, wait = 100) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn(...args), wait);
    };
}

function resetNameHeights(block) {
    const tops = block.querySelectorAll('.team-card .top-part');
    tops.forEach(n => n.style.minHeight = '');
}

// Remove global name equalization; we'll set top-part height per-row inside equalizeCardHeights

function equalizeCardHeights(block) {
    const cards = Array.from(block.querySelectorAll('.team-card'));
    if (!cards.length) return;
    // group cards by their top position (row)
    const rows = [];
    cards.forEach(card => {
        const top = Math.round(card.getBoundingClientRect().top);
        let row = rows.find(r => Math.abs(r.top - top) <= 2);
        if (!row) {
            row = { top, items: [] };
            rows.push(row);
        }
        row.items.push(card);
    });

    // for each row, compute max height of its .top-part and apply to each .top-part in the row
    rows.forEach(row => {
        const topParts = row.items.map(card => card.querySelector('.top-part')).filter(Boolean);
        if (!topParts.length) return;
        // reset
        topParts.forEach(tp => tp.style.minHeight = '');
        const max = Math.max(...topParts.map(tp => tp.offsetHeight));
        topParts.forEach(tp => tp.style.minHeight = max + 'px');
    });
}

const debouncedEqualize = debounce(() => {
    document.querySelectorAll('.team-block').forEach((block) => {
        // equalize top-part per-row (inside equalizeCardHeights)
        equalizeCardHeights(block);
    });
}, 120);

function handleSwiperInit() {
    const isMobile = window.innerWidth <= 768;
    const blocks = document.querySelectorAll('.team-block');

    if (isMobile) {
        // If mobile and no swipers initialized, initialize them
        if (swiperInstances.length === 0) {
            blocks.forEach((block) => {
                const container = block.querySelector('.swiper');
                if (!container) return;

                const swiper = new Swiper(container, {
                    modules: [Navigation],
                    spaceBetween: 20,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: block.querySelector('.swiper-button-next'),
                        prevEl: block.querySelector('.swiper-button-prev'),
                    },
                    breakpoints: {
                        513: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                    },
                });
                swiperInstances.push(swiper);

                // equalize after Swiper sets sizes (top-part per-row)
                setTimeout(() => {
                    equalizeCardHeights(block);
                }, 50);
            });
        }
    } else {
        // If desktop and swipers are initialized, destroy them
        if (swiperInstances.length > 0) {
            swiperInstances.forEach((swiper) => {
                if (typeof swiper.destroy === 'function') {
                    swiper.destroy(true, true);
                }
            });
            swiperInstances = [];

            // reset heights after destroying swipers and then equalize
            blocks.forEach(block => {
                resetNameHeights(block);
                equalizeCardHeights(block);
            });
        }
    }
}

// also listen for window resize and image loads
window.addEventListener('resize', debouncedEqualize);
window.addEventListener('load', () => debouncedEqualize());
document.addEventListener('DOMContentLoaded', () => debouncedEqualize());
document.addEventListener('lazyloaded', () => debouncedEqualize());

